import { useContext } from "react";

import { ComplianceTest } from "common/contexts";

import Img from "components/atoms/Img";

import style from "./Index.module.scss";

export default function QuizQuestion({ question }) {
  const {
    dataCompliance,
    setDataCompliance,
    questionIndex,
    setQuestionIndex,
    setChildrenShow,
    setDataChildren,
  } = useContext(ComplianceTest);

  function getUniqueListBy(arr, key) {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  }

  const handleClickAnswer = (e, answer) => {
    if (answer.compliance && Array.isArray(answer.compliance)) {
      let temp = getUniqueListBy(
        [...dataCompliance, ...answer.compliance],
        "title"
      );

      if (answer.condition && answer.condition?.length > 0) {
        temp = temp.filter((obj) => {
          return !answer.condition.includes(obj.title);
        });
      }
      setDataCompliance(temp);
    } else {
      if (answer.children && Array.isArray(answer.children)) {
        setChildrenShow(true);
        setDataChildren(answer.children);

        return;
      }
      setDataCompliance(
        dataCompliance.filter((obj) => {
          return !answer.condition.includes(obj.title);
        })
      );
    }
    setQuestionIndex(questionIndex + 1);
    setChildrenShow(false);
  };

  return (
    <div className={"paragraph mt-4 w-full lg:mt-8"}>
      {question.question && (
        <div className={style.QuestionTitle}>
          <div
            className={"text-bbc-brand-700 "}
            dangerouslySetInnerHTML={{ __html: question.question }}
          ></div>
        </div>
      )}

      <div className={"-mx-0.5 mt-6 mb-0"}>
        {question.answers &&
          question.answers.map((answers, awsIndex) => {
            return (
              <button
                key={awsIndex}
                className="my-1  w-full rounded-md border border-l-4 border-bbc-neutral-500 border-l-bbc-brand-500 bg-white px-4 py-4 text-left 
                transition-all duration-100 first:mt-0 hover:border-bbc-brand-500   hover:bg-bbc-brand-500 hover:text-white focus:outline-none"
                style={{ minHeight: "58px" }}
                onClick={(e) => {
                  handleClickAnswer(e, answers);
                }}
              >
                {answers.text}{" "}
              </button>
            );
          })}
      </div>
      {question.note && (
        <div
          className={
            "paragraph mt-4 bg-bbc-brand-100  font-normal leading-6 text-bbc-brand-700"
          }
          style={{
            padding: "26px 48px",
            border: "2px dashed #99c3ff",
            borderRadius: "12px",
          }}
        >
          <div className="mb-0 flex items-center">
            <Img
              width={139}
              height={61}
              src="/assets/icons/note.svg"
              alt="Note"
              className="mr-4"
              wrapper={{ style: { marginBottom: 0 } }}
            />
          </div>
          <div dangerouslySetInnerHTML={{ __html: question.note }}></div>
        </div>
      )}
    </div>
  );
}
